import { render, staticRenderFns } from "./wechatLogin.vue?vue&type=template&id=64d220d0&scoped=true"
import script from "./wechatLogin.vue?vue&type=script&lang=js"
export * from "./wechatLogin.vue?vue&type=script&lang=js"
import style0 from "./wechatLogin.vue?vue&type=style&index=0&id=64d220d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d220d0",
  null
  
)

export default component.exports